<template>
	<div id='simulat' class="warp_list1">
		<!-- <blacktitle></blacktitle> -->
		<div class='warp_list'>
			<div style="width: 10%;">
				<menulist :menulists='menulists'></menulist>
			</div>
			<div style="width: 90%;">
				<div style="width: 23%;">
					<tablelist :firstlist='fromdata.firstlist'></tablelist>
				</div>
				<div style="width: 32%;height: 40.6rem;position: relative;">
					<!-- height: 33rem; -->
					<div>
						<a-row>
							<a-col :span='12'>
								<div class='green-font font_warp' style="border-right: 1px solid #fff;">
									買入
								</div>
							</a-col>
							<a-col :span='12'>
								<div class='green-font font_warp'>
									賣出
								</div>
							</a-col>
						</a-row>
					</div>
					<setgetlist :setgetlist='fromdata.setgetlist'></setgetlist>
					<div class='blue-font font_warp'>交易記錄</div>
					<timelist :timelist='fromdata.timelist'></timelist>
					<div class='blue-font font_warp' style="position: relative;">
						<!-- <img :src="require('@/image/simu/backx.png')" alt="" style="position: absolute;
left: 0.2rem;width: 1rem;top: 0.5rem;"> -->
						相關資料
					</div>
					<div v-for='(item,ind) in fromdata.backlist' class='warp-div' :key='ind+"30102"'>
						{{item}}
					</div>
					<div style="position: absolute;bottom: 0;font-size: 1rem;">
						FIN DIV $1.70
						<br>
						REC:COB ON 20/5/21
					</div>
				</div>
				<div style="width: 45%;">
					<div class='blue-font bulu-border font_warp1' style="overflow: hidden;">
						<div style="float: left;">
							<img :src="treeimg1" alt="" style='width: 2.6rem;'>
							<img :src="treeimg2" alt="" style='width: 2.6rem;'>
							<img :src="treeimg3" alt="" style='width: 2.6rem;'>
						</div>
						長和
						<div style="float: right;"><input type="text" v-model="input"
								style="background-color: #338fff;width: 4rem;"></div>
					</div>
					<a-row>
						<a-col :span='12'>
							<div class='blue-font font_warp' style="border-right: 1px solid #fff;">買盤</div>
						</a-col>
						<a-col :span='12'>
							<div class='blue-font font_warp'>賣盤</div>
						</a-col>
						<a-col :span='12'>
							<a-row>
								<a-col :span='6' v-for='(item,indc) in fromdata.leftlist' :key='indc+"07010"'>
									<div v-if='item>0' class='warp-buul font_warp'>{{item}}</div>
									<div v-else class='blue-font font_warp blue-font1'>{{item}}</div>
								</a-col>
							</a-row>
						</a-col>
						<a-col :span='12'>
							<a-row>
								<a-col :span='6' v-for='(item,indk) in fromdata.rightlist' :key='indk+"0709"'>
									<div v-if='item<10' class='blue-font font_warp blue-font1'>{{item}}</div>
									<div v-else class='font_warp'>{{item}}</div>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
					<div class='blue-font font_warp bulu-border font_warp1'>www.aastocks.com</div>
					<a-row>
						<a-col :span='12'>
							<div class='blue-font font_warp font_warptop'>即市圖表</div>
						</a-col>
						<a-col :span='12'>
							<div class='blue-font font_warp'>技術分析資料</div>
						</a-col>
					</a-row>
					<linehcart :dataBol='true' :useData='{id:"lineChart11"}'
						:widthPxMess='{XYSize: 11.6143,legendSize: 11.6143,legendWidth: 108.188,titleSize: 15.91,}'>
					</linehcart>
				</div>

				<div id='border-bule'>
					<div style="width: 70%;display: inline-block;border-right: 1px solid #666;">
						<a-row v-for='(item,inds) in messagelist' :key='inds+"111222"'>
							<a-col :span='1'>
								<div style="margin-left: .1rem;" class='warp_lit'>
									{{item.data}}
								</div>
							</a-col>
							<a-col :span='1' class='warp_lit'>{{item.time}}</a-col>
							<a-col :span='20' class='warp_blue'>{{item.mess}}</a-col>
							<a-col :span='2' v-if='inds==0'><button>更多新聞</button></a-col>
						</a-row>
					</div>
					<div style="width: 30%;display: inline-block;vertical-align: top;">
						<a-row>
							<a-col :span='3'>
								<div style="margin-left: .1rem;" class='warp_lit'>
									{{messagefrom[0].data}}
								</div>
							</a-col>
							<a-col :span='3' class='warp_lit'>{{messagefrom[0].time}}</a-col>
							<a-col :span='18' class='warp_blue'>{{messagefrom[0].mess}}</a-col>
						</a-row>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class='btnback'>登出</div> -->
	</div>
</template>

<script>
	import blacktitle from './component/blacktitle'
	import menulist from './component/menulist'
	import tablelist from './component/tablelist'
	import setgetlist from './component/setgetlist'
	import timelist from './component/timelist'
	import linehcart from './component/linehcart'

	export default {
		components: {
			blacktitle,
			menulist,
			tablelist,
			setgetlist,
			timelist,
			linehcart
		},
		data() {
			return {
				input: '00001',
				treeimg1: require('@/image/simu/from.png'),
				treeimg2: require('@/image/simu/find.png'),
				treeimg3: require('@/image/simu/table.png'),
				messagefrom: [{
					data: '05-11',
					time: '15:00',
					mess: '[即市新聞] 騰訊控股(00700)出現大手買入1.13萬股。成交價$581.5 涉資657.095萬[AAFN]',
				}],
				messagelist: [{
					data: '05-11',
					time: '15:00',
					mess: '[即市新聞] 東京新增925宗確診[AAFN]',
				}, {
					data: '05-11',
					time: '14:57',
					mess: '[即市新聞] 晶片短缺可能會持續數年[AAFN]',
				}, {
					data: '05-11',
					time: '14:56',
					mess: '[即市新聞] 今日新增1宗輸入新館疫情[AAFN]',
				}, ],
				menulists: [{
					name: '證券買賣',
					type: '01',
					static: false,
					child: [{
						name: '港股交易',
						type: '11',
					}, {
						name: '美股交易',
						type: '12',
					}],
				}, {
					name: '新股認購',
					type: '04',
					static: false,
					child: [{
						name: '公開認購',
						type: '41',
					}, {
						name: '認購記錄',
						type: '42',
					}, ],
				}, {
					name: '投資組合',
					type: '07',
					static: false,
					child: [{
						name: '股票持有',
						type: '71',
					}, {
						name: '現金餘額',
						type: '72',
					}, ],
				}, {
					name: '交易記錄',
					type: '02',
					static: false,
					child: [ {
						name: '當日成交',
						type: '21',
					}, {
						name: '歷史成交',
						type: '23',
					}, {
						name: '歷史價格',
						type: '25',
					},{
						name: '待成交單',
						type: '24',
					},{
						name: '歷史委託',
						type: '22',
					}],
				}, {
					name: '存款提款',
					static: false,
					type: '03',
					child: [{
						name: '提款指示',
						type: '31'
					}, {
						name: '存款通知',
						type: '32'
					}, {
						name: '提存記錄',
						type: '33'
					}],
				}, {
					name: '帳戶管理',
					type: '05',
					static: false,
					child: [{
						name: '更改密碼',
						type: '51',
						// }, {
						// 	name: '衍生產品條款',
						// 	type:'52',
					}],
				}, {
					name: '其他',
					type: '06',
					static: false,
					child: [{
						name: '申請報價',
						type: '61',
					}, {
						name: '示範',
						type: '62',
					}],
				}, ],
				fromdata: {
					firstlist: [{
							name: '最高價',
							num: '65.650'
						},
						{
							name: '最底價',
							num: '65.650'
						},
						{
							name: '開市價',
							num: '65.650'
						},
						{
							name: '前收市價',
							num: '65.650'
						},
						{
							name: '現價',
							num: '65.650'
						},
						{
							name: '升跌($)',
							num: '-1.700',
							color: 'red'
						},
						{
							name: '升跌(%)',
							num: '-2.568%',
							color: 'red'
						},
						{
							name: '成交量',
							num: '4.85百萬'
						},
						{
							name: '成交金額',
							num: '3.13億'
						},
						{
							name: '平均價',
							num: '65.650'
						},
						{
							name: 'IEP/IEV',
							num: '-'
						},
						{
							name: '每手股數',
							num: '500'
						},
						{
							name: '差價',
							num: '0.05/0.05'
						},
						{
							name: '52遇最高',
							num: '65.650'
						},
						{
							name: '52遇最低',
							num: '45.800'
						},
						{
							name: '市盈率',
							num: '8.650'
						},
						{
							name: '收益率',
							num: '3.61%'
						},
						{
							name: '派息',
							num: '2.650'
						},
						{
							name: '每股盈利',
							num: '7.650'
						},
						{
							name: '已發行股本',
							num: '7354.60M'
						},
						{
							name: '市值',
							num: '2469.79億'
						},
						{
							name: '貨幣',
							num: 'HKD'
						},

					],
					setgetlist: ['63.950', '64,050', '21.6%', '78.4%', '5.5K (   6)',
						'20K(  9)', '46.5(  18)', '20.5k(  8)', '36k(  12)', '28.5k(   5)',
						'36.5k(  18)', '28k(  6)', '84.5k(  18)', '26k(  10)'
					],
					timelist: [{
						time: '15:10:24',
						set: '1000',
						bnum: '64.025',
						a: 'A'
					}, {
						time: '15:10:13',
						set: '500',
						bnum: '64.000',
						a: 'U'
					}, {
						time: '15:10:07',
						set: '28.5k',
						bnum: '64.000',
						a: 'B'
					}, {
						time: '15:10:24',
						set: '1000',
						bnum: '64.025',
						a: 'A'
					}, {
						time: '15:10:04',
						set: '500',
						bnum: '64.100',
						a: 'A'
					}, {
						time: '15:09:56',
						set: '500',
						bnum: '64.100',
						a: 'A'
					}, ],
					backlist: ['12661C',
						'17190C',
						'19286C',
						'20563C',
						'23868C',
						'25647P',
						'13231C',
						'17683C',
						'19971C',
						'20968C',
						'24317C',
						'25706C',
						'13431C',
						'18294C',
						'20279C',
						'21540C',
						'25411C',
						'26223C',
						'13567C',
						'18752C',
						'20401C',
						'22783C',
						'25574C',
						'29445P',
						'16877C',
						'18949C',
						'20506C',
						'23295C',
						'25584C',
						'29883C'
					],
					leftlist: ['0460', '1048', '5336', '1799',
						'4378', '1048', '5338', '1799',
						'6728', '8578', '5336', '2029',
						'3440', '8463', '5347', '1450',
						'3439', '9023', '2311', '1048',
						'7190', '7389', '-2', '0317',
						'-1', '9023', '2311', '8176',
						'8302', '2311', '8578', '5346',
						'5368', '6698', '8145', '-3',
						'5515', '1799', '8145', '1450'
					],
					rightlist: [
						'1048', '0517', '8565', '2077',
						'6698', '1450', '1048', '+4',
						'1049', '1450', '4974', '8565',
						'4973', '4975', '2079', '1048',
						'4377', '4975', '+3', '8564',
						'7389', '4974', '1450', '8565',
						'5338', '8564', '1778', '8565',
						'2576', '2576', '8564', '8565',
						'6036', '+2', '1048', '1450',
						'1', '1450', '4974', '2077',
					]
				}
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style lang="scss">
	.warp_lit {
		color: #666;
		font-size: .8rem;
	}

	.warp_blue {
		color: #3177bd;
		font-size: .8rem;
	}

	#border-bule {
		border: 1px solid #c5e3ff;
		display: block;
		height: 4rem;
		overflow: hidden;
	}

	// .btnback {
	// 	position: fixed;
	// 	bottom: .2rem;
	// 	left: .1rem;
	// 	width: 10%;
	// 	background-color: #25bcca;
	// 	color: #fff;
	// 	height: 1.8rem;
	// 	line-height: 1.8rem;
	// 	text-align: center;
	// }

	.warp_list>div {
		display: inline-block;
		vertical-align: top;
	}

	.warp_list>div>div {
		display: inline-block;
		vertical-align: top;
	}

	.warp_list1 {
		// height: 100vh;
		height: '(100vh - 3rem)';
		background-color: #e3effb;
	}

	.green-font {
		background-color: #0c8b97;
		color: #fff;
		text-align: center;
		font-size: .8rem;
	}

	.blue-font {
		background-color: #0c8b97; //3177bd
		color: #fff;
		text-align: center;
	}

	.blue-font1 {
		background-color: #3177bd;
	}

	.warp-div {
		display: inline-block;
		width: 20%;
		font-size: 1rem;
	}

	.bulu-border {
		border-bottom: 1px solid #5994d0;
		font-size: 1rem;
	}

	.warp-buul {
		background-color: #bfd9f2;
	}

	.font_warp {
		text-align: center;
		padding: .2rem 0;
		font-size: 1rem;
	}

	.font_warp:before {
		
	}

	.font_warptop:after {
		content: '';
		width: 0;
		height: 0;
		position: absolute;
		border: 10px solid;
		border-color: transparent transparent #fff transparent;
		left: 9.6rem;
		top: .8rem;
		// border-bottom: 0;
	}

	.font_warp1 {
		font-size: 1.2rem;
	}
</style>
